module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-sieron-rise-above-your-body-kinesitherapie-brakel-2.0b7af27d.jpg";